import { Avatar, AvatarGroup, Chip, Paper, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import DragHandleOutlinedIcon from "@mui/icons-material/DragHandleOutlined";
import { Box, Stack } from "@mui/system";
import GroupedOccurrencesTable from "./GroupedOccurrencesTable";
// import CommentsAndFiles from "../../../../Discussion/CommentsAndFiles";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  filterAndGroupTasks,
  mapOwnersToNames,
} from "../DataAccuracyHelpers/helpers";
import { formatDate } from "../../../../../utils/helpers";
import { selectAllUsers } from "../../../../../features/userSlice";
import { useEffect, useMemo } from "react";

const TaskNameDataAccuracy = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { tasksByTaskStructureSharedUid = [], dataAccruracyData } = useSelector(
    (state: any) => state.dataAccuracy || {}
  );
  const taskStructureSharedUid = searchParams.get("task_structure_shared_uid");

  const filterdTaskDetails = filterAndGroupTasks(
    dataAccruracyData?.query_output,
    taskStructureSharedUid
  );

  const lastUpdatedFromTasks = useMemo(() => {
    if (!tasksByTaskStructureSharedUid?.length) return "";

    return tasksByTaskStructureSharedUid
      .map((task: any) => task.modified_at)
      .filter(Boolean)
      .sort(
        (a: string, b: string) => new Date(b).getTime() - new Date(a).getTime()
      )[0];
  }, [tasksByTaskStructureSharedUid]);

  const firstTask = filterdTaskDetails?.[0] || {};

  const {
    title = "",
    websites = [],
    category = "",
    owners = [],
    // last_updated = "",
    priority = "",
    description = "",
  } = firstTask;

  const allUsers = useSelector(selectAllUsers);
  const ownerNames = mapOwnersToNames(owners, allUsers);

  useEffect(() => {
    if (title) {
      const newParams = new URLSearchParams(searchParams);
      if (newParams.get("taskTitle") !== title) {
        newParams.set("taskTitle", title);
        setSearchParams(newParams, { replace: true });
      }
    }
    // eslint-disable-next-line
  }, [title]); // Only depend on title, not searchParams

  return (
    <>
      <Paper sx={{ padding: "8px 16px" }}>
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="h6" component="h2" gutterBottom>
            {title}
          </Typography>
          <>
            {priority?.toLowerCase() === "high" ? (
              <KeyboardArrowUpIcon sx={{ color: "#D32F2F" }} />
            ) : priority?.toLowerCase() === "low" ? (
              <KeyboardArrowDownIcon sx={{ color: "#2196F3" }} />
            ) : priority?.toLowerCase() === "lowest" ? (
              <KeyboardDoubleArrowDownIcon sx={{ color: "#2196F3" }} />
            ) : priority?.toLowerCase() === "highest" ? (
              <KeyboardDoubleArrowUpIcon sx={{ color: "#D32F2F" }} />
            ) : priority?.toLowerCase() === "medium" ? (
              <DragHandleOutlinedIcon sx={{ color: "#ED6C02" }} />
            ) : null}
          </>
          {websites?.map((website: string, index: number) => (
            <Chip
              key={index}
              label={website}
              color="secondary"
              sx={{
                height: "26px",
              }}
            />
          ))}
        </Stack>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            fontSize: "14px",
            mt: 0.5,
          }}
        >
          {/* Category */}
          <Typography variant="body2">
            <Typography component="span" sx={{ fontWeight: 500 }}>
              Category:
            </Typography>{" "}
            {category}
          </Typography>

          {/* Owners */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2">
              <Typography component="span" sx={{ fontWeight: 500 }}>
                Owners:
              </Typography>
            </Typography>
            <AvatarGroup
              max={3}
              sx={{ "& .MuiAvatar-root": { width: 24, height: 24 } }}
            >
              {ownerNames?.map((owner: string, index: number) => (
                <Avatar
                  key={index}
                  alt={owner.toUpperCase()}
                  src="/static/images/avatar/1.jpg"
                />
              ))}
            </AvatarGroup>
          </Box>

          {/* Created on */}
          {/* <Typography variant="body2">
            <Typography component="span" sx={{ fontWeight: 500 }}>
              Created on:
            </Typography>{" "}
            21/03/23
          </Typography> */}

          {/* Last Updated */}
          <Typography variant="body2">
            <Typography component="span" sx={{ fontWeight: 500 }}>
              Last Updated:
            </Typography>{" "}
            {lastUpdatedFromTasks ? formatDate(lastUpdatedFromTasks) : " "}
          </Typography>
        </Box>
        <Typography variant="body2" mt={0.5} color="text.secondary">
          {
            tasksByTaskStructureSharedUid[0]?.data?.["meta_data:website_name"]
              ?.description
          }
        </Typography>
        <Stack direction="row">
          <Typography gutterBottom>{description}</Typography>
        </Stack>
      </Paper>
      <Paper sx={{ padding: "8px 16px", marginTop: 2 }}>
        <GroupedOccurrencesTable />
      </Paper>
    </>
  );
};

export default TaskNameDataAccuracy;
